<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Nama</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="name"
          class="w-full sidebar-input"
          v-model="formData.name"
          placeholder="Isi Dengan Nama Kode Akun"
        />
        <span class="text-danger text-sm">{{ errors.first("name") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Kode</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          @keypress="onlyNumber"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="code"
          class="w-full sidebar-input"
          v-model="formData.kode"
          placeholder="Isi Dengan Kode Akun"
        />
        <span class="text-danger text-sm">{{ errors.first("code") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Debit</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="[
            {
              id: 1,
              text: '- (Minus)',
            },
            {
              id: 2,
              text: '+ (Plus)',
            },
          ]"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          name="debit"
          label="text"
          v-model="formData.debit"
          placeholder="Pilih Debit"
        />
        <span class="text-danger text-sm">{{ errors.first("debit") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Kredit (Rp)</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          @keypress="onlyNumber"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="credit"
          class="w-full sidebar-input"
          v-model="nominal"
          placeholder="Isi Dengan Kredit (Rp)"
        />
        <span class="text-danger text-sm">{{ errors.first("credit") }}</span>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 rounded-2xl"
          :disabled="!validateForm"
          @click="addData"
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
export default {
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      formData: {
        name: "",
        kode: null,
        debit: null,
        kredit: null,
      },
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null ? "Edit Kode Akun" : "Tambah Kode Akun";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    nominal: {
      get() {
        return this.formatRupiah(this.formData.kredit);
      },
      set(val) {
        // Do something with the val here...
        this.formData.kredit = val;
      },
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.name !== "" &&
        this.formData.kode !== null &&
        this.formData.debit !== null &&
        this.formData.kredit !== null
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    activate() {
      if (this.passData !== null) {
        this.formData.name = this.passData.name;
        this.formData.kode = this.passData.kode;
        this.formData.debit = this.passData.debit;
        this.nominal = this.passData.kredit.toString();
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.formData.name = "";
      this.formData.kode = null;
      this.formData.debit = null;
      this.formData.kredit = null;
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addData() {
      this.$vs.loading({
        color: "primary",
      });
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      this.formData.kredit = this.formData.kredit.replaceAll(".", "");
      this.$store
        .dispatch("journal/cudKodeAkun", [{ ...this.formData, ...id }])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null
                ? "Edit Kode Akun Sukses!"
                : "Tambah Kode Akun Sukses!",
            text:
              this.passData !== null
                ? `Kode Akun ${v.name} Berhasil diedit`
                : `Kode Akun ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
        });
    },
  },
};
</script>
